export enum VoxSource {
  ARGYLE = 'VOX_ARGYLE',
  PLAID = 'VOX_PLAID',
  TRUV = 'VOX_TRUV',
}

export enum VoxEventType {
  LOAD = 'LOAD',
  ERROR = 'ERROR',
  EMPLOYER_SELECTED = 'EMPLOYER_SELECTED',
  COMPLETE = 'COMPLETE',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  UNDEFINED = 'UNDEFINED',
}

export const postMessage = ({
  eventType,
  payload,
  _metadata,
}: {
  eventType: VoxEventType;
  payload?: any;
  _metadata?: any;
}) => {
  console.log(`[${_metadata?.source}] postMessage`, { eventType, payload, _metadata });
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(
      {
        eventType,
        payload,
        _metadata,
      },
      '*'
    );
  }
};